import { MutationTree } from 'vuex';
import { ECreateFieldMutation } from './create-field.constants';
import { ICreateFieldState } from './create-field.types';
import { IField } from '@lib-shared/fields/types/field';

export const mutations: MutationTree<ICreateFieldState> = {
  [ECreateFieldMutation.SetCreatedFieldsData](
    state: ICreateFieldState,
    data: { tempId: string; field: IField }[]
  ) {
    state.createdFieldsData = data;
  },
  [ECreateFieldMutation.SetOptimisticallyCreatedFields](
    state: ICreateFieldState,
    fields: IField[]
  ) {
    state.optimisticallyCreatedFields = fields;
  },
  [ECreateFieldMutation.SetUnsuccessfullyCreatedFields](
    state: ICreateFieldState,
    fields: IField[]
  ) {
    state.unsuccessfullyCreatedFields = fields;
  },
  [ECreateFieldMutation.SetState](state: ICreateFieldState, newState: ICreateFieldState) {
    Object.assign(state, newState);
  },
};
